export default __webpack_public_path__ + "static/media/tge-logo-lockup-dark-fern-rgb.5044264a.svg";